/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import '../../styles/components/AsperaDataTable.scss';
import { language } from '../../services/LanguageService';
import { dragging } from '../../services/DragDropService';
import { modal } from '../../services/ModalService';
import { AsperaTableData } from '../../classes/AsperaTableData';
import { withRouter } from 'react-router-dom';
import { getQueryParams, getParamString, iterableToArray, getRandomId, clearFocus, doesElementParentHaveClass, getEnvironmentVar } from '../../helpers/helpers';
import { altKeysUsed, generateTableDataUpdate, resetTableStore } from '../../helpers/starterHelpers';
import { downloadTableAsCsv } from '../../helpers/components';
import { Axios } from '../../classes/Axios';
import { SubManager } from '../../classes/SubManager';
import { AsperaError } from '../../classes/AsperaError';
import AsperaCellText from './AsperaCellText';
import AsperaCellImage from './AsperaCellImage';
import AsperaCellIcon from './AsperaCellIcon';
import { Subject, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AsperaContextMenu } from '../AsperaContextMenu';
import AsperaCellLink from './AsperaCellLink';
import AsperaCellTags from './AsperaCellTags';
import { onePixelClearImage } from '../../constants/data';
import { monitorDrops } from '../../helpers/transfer';
import AsperaDataTableSkeleton from './AsperaDataTableSkeleton';
import { tracking } from '../../services/TrackingService';
import { AsperaEmptyState } from '../AsperaEmptyState';
import { AsperaErrorState } from '../AsperaErrorState';
import { notification } from '../../services/NotificationService';
import { AsperaForm } from '../AsperaForm';
import { AsperaOverflowButton } from '../AsperaOverflowButton';
import AsperaTablePagination from './AsperaTablePagination';
import { Button, Checkbox, OverflowMenuItem, OverflowMenu, RadioButton, TableContainer, TableCell, TableToolbarMenu, TableToolbarAction, TableBatchActions, TableBatchAction, TableToolbar, TableToolbarContent, TableToolbarSearch, TableBody, TableSelectRow, TableExpandRow, TableExpandedRow, TableRow, Table, TableHead, TableExpandHeader, TableSelectAll, TableHeader, getIconComponent } from '../Carbon';
export const standardColumnWidth = {
    date: 160,
    status: 140,
    size: 200,
    sizeOneCount: 140,
    recipient: 240,
};
/** Advanced filter form class for rendering the form for the Modal (modalClose needed so had to pass it in) */
class AdvancedFilterForm extends React.Component {
    constructor() {
        super(...arguments);
        this.subManager = new SubManager();
        this.validFormSubject = new Subject();
    }
    componentDidMount() {
        const { disableSubject } = this.props;
        this.subManager.setSubscription(this.validFormSubject.subscribe({
            next: valid => {
                disableSubject.next(!valid);
            },
            error: () => {
                disableSubject.next(false);
            },
        }));
    }
    componentWillUnmount() {
        const { modalClose } = this.props;
        this.subManager.unsubscribeAll();
        modalClose({});
    }
    render() {
        const { filterModel, items } = this.props;
        return React.createElement(AsperaForm, { validFormSubject: this.validFormSubject, formDetails: {
                model: filterModel,
                id: 'advanced-filter-form',
                items: items,
            } });
    }
}
/**
 * React Component
 *
 * The AsperaDataTable provides the customized version of the Carbon DataTable with Aspera tweaks.
 * All paging logic and everything happens inside this component.
 *
 * TODO: Drag events are caused multiple times when hovering Row children
 *
 * @example
 * ```javascript
 * <AsperaDataTable apiData={apiData} />
 * ```
 */
export const AsperaDataTable = withRouter(class AsperaDataTable extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            loading: true,
            error: false,
            contextMenuProps: undefined,
            paginationSmall: false,
            overloadedToolBar: false,
            paginationLoading: false,
        };
        /** Default empty state text */
        this.defaultEmptyProps = {
            title: language.get('table.emptyTable'),
            body: language.get('table.emptyTableDescription'),
        };
        /** Default empty state text */
        this.defaultSearchEmptyProps = {
            title: language.get('table.emptyTable'),
            body: language.get('table.emptyTableDescription'),
        };
        this.nextTokens = {
            next: '',
            first: '',
        };
        this.tableData = new AsperaTableData();
        this.firstLoad = true;
        this.supportCustomColumns = false;
        this.customizedTable = false;
        this.disablePaginationInternal = false;
        this.subManager = new SubManager();
        this.internalItems = new Map();
        this.totalItems = 0;
        this.filterSub = new Subject();
        this.forceRowUpdater = new Subject();
        this.checkedItems = new Map();
        this.idPrefixToUse = '';
        this.currentRenderedHeaders = new Map();
        this.advancedFilterModel = {};
        this.advancedFilterData = {};
        this.lastPaginationDifference = 0;
        this.originalUrl = '';
        this.hasResize = false;
        /** Resize in progress event tracking store */
        this.resizeInProgressItem = {
            headerKey: '',
            startWidth: undefined,
            start: undefined,
            current: undefined,
        };
        this.changePage = (pageData) => {
            const callGetRow = (direction) => {
                this.tableData.page = pageData.page;
                this.tableData.pageSize = pageData.pageSize;
                if (direction === 'FIRST') {
                    this.tableData.page = 1;
                }
                this.getRowData(direction);
            };
            if (this.isBlindPaging) {
                if (this.tableData.page < pageData.page) {
                    if (!this.nextTokens.next) {
                        notification.create('warning', language.get('table.noMorePages'));
                    }
                    else {
                        callGetRow('NEXT');
                    }
                }
                else {
                    if (!this.nextTokens.first) {
                        notification.create('warning', language.get('table.noMorePriorPages'));
                    }
                    else {
                        callGetRow('FIRST');
                    }
                }
                return;
            }
            callGetRow();
        };
        this.handleClick = (row) => {
            const { handleClick } = this.props;
            if (typeof handleClick === 'function') {
                handleClick(row);
            }
        };
        this.resetToFirst = () => {
            const { blindPagingUrlExchange, apiData } = this.props;
            this.tableData.page = 1;
            this.nextTokens.next = '';
            this.nextTokens.first = '';
            if (typeof blindPagingUrlExchange === 'function' && apiData && this.originalUrl) {
                apiData.url = this.originalUrl;
            }
            this.setState({ paginationLoading: true }, () => {
                this.setState({ paginationLoading: false });
            });
        };
        this.sort = (key) => {
            if (!key)
                return;
            if (key === this.tableData.sortKey) {
                this.tableData.sortKey = this.tableData.isSortReversed ? key : `-${key}`;
            }
            else {
                this.tableData.sortKey = key;
            }
            this.resetToFirst();
            this.getRowData();
        };
        this.filter = () => {
            const { staticRowData, disableInternalFilter } = this.props;
            tracking.track('Performed Search', { data: this.tableData.filterText, type: 'Data Table Search', successFlag: true });
            this.resetToFirst();
            if (!staticRowData) {
                if (!disableInternalFilter) {
                    this.getRowData();
                }
            }
            else {
                this.setState({});
            }
        };
        this.handleRightClick = (id, row, event) => {
            const { getOverflowMenu, batchActions } = this.props;
            event.preventDefault();
            if (doesElementParentHaveClass(event.target, 'cds--overflow-menu-options') || doesElementParentHaveClass(event.target, 'cds--overflow-menu')) {
                return;
            }
            const batchMode = !!this.checkedItems.get(id) && this.checkedItems.size > 1;
            const items = batchMode ? iterableToArray(this.checkedItems.values()) : [row];
            let options;
            if (batchMode) {
                options = batchActions ? batchActions.filter(action => !action.hidden).map(action => {
                    return {
                        name: action.name,
                        disabled: action.disableCheck ? action.disableCheck(items) : false,
                        onClick: (items) => {
                            action.onClick(items);
                            this.batchSelect('CLEAR');
                        },
                    };
                }) : [];
            }
            else {
                options = getOverflowMenu ? getOverflowMenu(row).filter(menu => !menu.hidden) : [];
            }
            this.setState({
                contextMenuProps: {
                    onClose: () => {
                        this.setState({ contextMenuProps: undefined });
                    },
                    openCoordinate: {
                        x: event.clientX,
                        y: event.clientY,
                    },
                    menuOptions: options,
                    itemsSelected: items,
                },
            });
        };
        this.batchSelect = (id, row) => {
            const { onBatchChange } = this.props;
            if (id === 'CLEAR') {
                this.checkedItems.clear();
            }
            else if (id === 'ALL') {
                if (this.allItemsChecked) {
                    this.rows.filter(row => !(row.tableRowDisabled || row.tableRowNotSelectable)).forEach(row => {
                        const id = String(row[this.idToUse]);
                        this.checkedItems.delete(id);
                    });
                }
                else {
                    this.rows.filter(row => !(row.tableRowDisabled || row.tableRowNotSelectable)).forEach(row => {
                        const id = String(row[this.idToUse]);
                        this.checkedItems.set(id, row);
                    });
                }
            }
            else if (this.checkedItems.get(id)) {
                this.checkedItems.delete(id);
            }
            else {
                this.checkedItems.set(id, row);
            }
            if (typeof onBatchChange === 'function')
                onBatchChange(iterableToArray(this.checkedItems.values()));
            this.setState({});
        };
        this.setAdvancedFilterModel = () => {
            const { advancedFilterQueryExchange, overrideDefaultFilterParam } = this.props;
            if (!advancedFilterQueryExchange)
                return;
            const paramParts = advancedFilterQueryExchange(this.advancedFilterModel);
            if (typeof paramParts[overrideDefaultFilterParam || 'q'] === 'string') {
                this.tableData.filterText = paramParts[overrideDefaultFilterParam || 'q'];
                delete paramParts[overrideDefaultFilterParam || 'q'];
            }
            this.advancedFilterData = paramParts;
            this.tableData.advancedFilterModel = this.advancedFilterModel;
        };
        this.handleAdvancedFilter = () => {
            const { advancedFilters, advancedFilterQueryExchange } = this.props;
            if (!advancedFilterQueryExchange || !advancedFilters)
                return;
            const modalInfo = modal.prepare();
            const disableSubject = new Subject();
            const modalProps = {
                modalHeading: language.get('table.advancedFilters'),
                primaryButtonText: language.get('table.apply'),
                shouldSubmitOnEnter: true,
            };
            advancedFilters.forEach(filter => {
                if (filter.type === 'autocomplete' && filter.autoCompleteProps && filter.pointer) {
                    filter.autoCompleteProps.initialItems = this.advancedFilterModel[filter.pointer] || undefined;
                }
            });
            this.subManager.setSubscription(modal.create(modalInfo.id, modalProps, React.createElement(AdvancedFilterForm, { items: advancedFilters, modalClose: modalInfo.callback, filterModel: this.advancedFilterModel, disableSubject: disableSubject }), disableSubject.asObservable()).subscribe({
                next: () => {
                    this.setAdvancedFilterModel();
                    this.getRowData();
                },
                error: () => { },
            }));
        };
        this.translateBatch = (id, state) => {
            const translationKeys = {
                'carbon.table.batch.cancel': 'table.cancel',
                'carbon.table.batch.items.selected': 'table.itemSelected',
                'carbon.table.batch.item.selected': 'table.itemSelected',
            };
            if (id === 'carbon.table.batch.cancel') {
                return language.get(translationKeys[id] || 'table.unknown');
            }
            return language.get(translationKeys[id] || 'table.unknown', [state.totalSelected]);
        };
        this.getBatchItems = () => {
            const { batchActions } = this.props;
            const maxItems = Math.floor((this.clientWidth - 177) / 200);
            let mainItems = (batchActions || []).filter(action => !action.hidden).slice(0, maxItems);
            let menuItems = (batchActions || []).filter(action => !action.hidden).slice(maxItems);
            if (menuItems.length === 1) {
                mainItems = (batchActions || []).filter(action => !action.hidden);
                menuItems = [];
            }
            const checkAction = (action) => {
                action.onClick(iterableToArray(this.checkedItems.values()));
                this.batchSelect('CLEAR');
            };
            const items = iterableToArray(this.checkedItems.values());
            // This does not go through Aspera Translation.  I don't see a way in Carbon to do this...  Waiting on them right now.
            return (React.createElement(TableBatchActions, { shouldShowBatchActions: this.showingBatchActions, totalSelected: this.checkedItems.size, "data-auto": "table-batch-action", translateWithId: this.translateBatch, onCancel: () => {
                    this.batchSelect('CLEAR');
                } },
                mainItems.map((action, index) => {
                    return (React.createElement(TableBatchAction, { key: index, "data-auto": `table-batch-action-item-${action.name}`, disabled: action.disableCheck ? action.disableCheck(items) : false, kind: action.kind, renderIcon: action.icon ? action.icon : null, onClick: () => {
                            checkAction(action);
                        } }, action.name));
                }),
                !!menuItems.length && (React.createElement(AsperaOverflowButton, { name: mainItems.length ? language.get('table.more') : language.get('table.actions'), id: "batch-action-more", icon: getIconComponent('ChevronDown'), items: menuItems.map(item => {
                        return {
                            id: `batch-action-item-${item.name}`,
                            name: item.name,
                            disabled: item.disableCheck ? item.disableCheck(items) : false,
                            onClick: () => {
                                checkAction(item);
                            },
                        };
                    }) }))));
        };
        /** Check that target and currentTarget are same (means that user clicked directly on the element not a child) */
        this.handleToolbarAreaClick = (event) => {
            const { tableId } = this.props;
            if (event && event.currentTarget && event.target && event.currentTarget === event.target) {
                const element = document.querySelector(`#${tableId} .cds--search-input`);
                if (element && typeof element.focus === 'function') {
                    element.focus();
                }
            }
        };
        this.translateToolbarSearch = (id) => {
            const { filterPlaceholderKey } = this.props;
            const translationKeys = {
                'carbon.table.toolbar.search.label': filterPlaceholderKey || 'table.filterTable',
                'carbon.table.toolbar.search.placeholder': filterPlaceholderKey || 'table.filterTable',
            };
            return language.get(translationKeys[id] || 'table.unknown');
        };
        this.radioSelect = (id, row) => {
            const { radioOnSelect } = this.props;
            this.radioSelectedRow = id;
            if (typeof radioOnSelect === 'function')
                radioOnSelect(row);
            this.setState({});
        };
        /** If expandable rows are in use the column span needs to be calculated based on how many are rendered; not how many are actually set. */
        this.checkExpandableSettings = () => {
            const hasExpandable = !!this.rows.filter(row => row.tableRowExpandedContent).length;
            if (hasExpandable) {
                this.setState({});
            }
        };
        this.dragColumnClick = (event) => {
            event.stopPropagation();
        };
        this.dragColumnDown = (event, header) => {
            const { tableId } = this.props;
            event.stopPropagation();
            event.preventDefault();
            const element = document.querySelector(`#${tableId} [data-auto="table-header-item-${header.sortKey || header.name}"]`);
            if (element) {
                this.resizeInProgressItem.headerKey = header.key;
                this.resizeInProgressItem.start = event.pageX;
                this.resizeInProgressItem.startWidth = element.clientWidth;
            }
            else {
                new AsperaError('AsperaDataTable: unable to find header for resize');
            }
        };
        this.getHeaders = () => {
            const totalResizableColumns = this.currentHeaderItems.filter(header => ['text', 'link'].includes(header.type));
            return this.currentHeaderItems.map(header => {
                let width = '';
                const canResize = ['text', 'link'].includes(header.type) && window.innerWidth > 720 && totalResizableColumns.length >= 2;
                if (header.width) {
                    width = `${header.width}px`;
                }
                else if (header.type === 'icon' || header.type === 'image') {
                    width = '48px';
                }
                const overrideWidth = this.tableData.getTableSizing(header.key);
                if (overrideWidth && canResize) {
                    width = `${overrideWidth}px`;
                    this.hasResize = true;
                }
                let sortDirection = 'NONE';
                if (this.tableData.sortKey === header.sortKey) {
                    sortDirection = this.tableData.isSortReversed ? 'DESC' : 'ASC';
                }
                const isSortable = !!header.sortKey;
                return (React.createElement(TableHeader, { onClick: () => {
                        if (!this.resizeInProgressItem.headerKey) {
                            this.sort(header.sortKey);
                        }
                    }, ref: (refElement) => {
                        const element = refElement;
                        // Carbon sets `rest` attributes to button for sortable row; we need it on TH for width to work
                        if (isSortable && element && element.tagName === 'TH' && typeof element.style === 'object' && width) {
                            element.style.width = width;
                        }
                    }, isSortable: isSortable, "data-auto": `table-header-item-${header.sortKey || header.name}`, isSortHeader: sortDirection !== 'NONE', sortDirection: sortDirection, key: header.key, className: `aspera-cell-importance-${header.importance || 'primary'} ${canResize ? 'has-resizing' : ''}`, style: (width && !isSortable) ? { width } : undefined },
                    header.name,
                    canResize && React.createElement("div", { className: "table-resize-dragger", onClick: this.dragColumnClick, onMouseDown: event => this.dragColumnDown(event, header) })));
            });
        };
        this.getTableText = (row, key, formatter) => {
            if (!key) {
                return '';
            }
            let valueToUse = row[key];
            if (key.indexOf('.') > -1) {
                const keys = key.split('.');
                if (keys[0] && keys[1] && typeof row[keys[0]] === 'object') {
                    valueToUse = row[keys[0]][keys[1]];
                }
            }
            if (typeof formatter === 'function') {
                return (formatter(valueToUse, row));
            }
            return valueToUse;
        };
        this.getTableCell = (row, id, header, index) => {
            const { handleClick } = this.props;
            const importance = header.importance || 'primary';
            const sharedProps = {
                handleClick: this.handleClick,
                row: row,
                rowId: id,
                header: header,
                getTableText: this.getTableText,
                forceUpdater: this.forceRowUpdater.asObservable(),
                className: `${handleClick ? 'clickable-row' : ''} aspera-cell-importance-${importance}`,
            };
            switch (header.type) {
                case 'icon':
                    return React.createElement(AsperaCellIcon, Object.assign({ key: index }, sharedProps));
                case 'image':
                    return React.createElement(AsperaCellImage, Object.assign({ key: index }, sharedProps));
                case 'link':
                    if (typeof header.linkOnClick !== 'function')
                        new AsperaError('AsperaDataTable: Type link was used without linkOnClick');
                    return React.createElement(AsperaCellLink, Object.assign({ key: index }, sharedProps, { className: `aspera-cell-importance-${importance}` }));
                case 'tags':
                    if (typeof header.setTags !== 'function')
                        new AsperaError('AsperaDataTable: Type tags was used without setTags');
                    return React.createElement(AsperaCellTags, Object.assign({ key: index }, sharedProps));
                case 'text':
                default:
                    return React.createElement(AsperaCellText, Object.assign({ key: index }, sharedProps, { overrideTitle: header.overrideTitle }));
            }
        };
        this.startDraggingItems = (id, row, event) => {
            var _a;
            const { tableId } = this.props;
            if (typeof event.dataTransfer.setDragImage === 'function') {
                let emptyImage = document.querySelector('#aspera-empty-image');
                if (!emptyImage) {
                    emptyImage = document.createElement('img');
                    emptyImage.src = onePixelClearImage;
                    (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.appendChild(emptyImage);
                }
                event.dataTransfer.setDragImage(emptyImage, 0, 0);
            }
            const batchMode = !!this.checkedItems.get(id);
            const items = batchMode ? iterableToArray(this.checkedItems.values()) : [row];
            dragging.itemsDragged = items;
            dragging.tableIdDragging = tableId;
            this.handleDragEvent(row, id, event);
        };
        this.handleDragEvent = (item, _id, event) => {
            const { onDrag, tableId } = this.props;
            let dragOverProps = undefined;
            const draggedItems = dragging.safeCurrentItemsDragged;
            if (typeof onDrag === 'function' && draggedItems.length) {
                dragOverProps = onDrag(item, draggedItems, event);
            }
            dragging.dragOverItem = item;
            dragging.dragOverItemTableId = tableId;
            if (dragOverProps) {
                dragging.setDragRules(dragOverProps);
            }
        };
        this.handleDropEvent = (item, event) => {
            const { onDrop, onDrag, tableId, droppable } = this.props;
            const draggedItems = dragging.safeCurrentItemsDragged;
            if (!item && !droppable) {
                return;
            }
            if (typeof onDrop === 'function' && draggedItems.length) {
                let dragCheck = { mainText: '', allowed: true };
                if (typeof onDrag === 'function') {
                    dragCheck = onDrag(item, draggedItems, event);
                }
                if (dragCheck.allowed) {
                    onDrop(item || tableId, draggedItems, dragCheck.defaultBehavior === 'MOVE' ? !altKeysUsed(event) : altKeysUsed(event), event, false);
                }
            }
            dragging.triggerResetDrag();
        };
        this.checkOverloadedToolbar = () => {
            const { tableId, disableFilter } = this.props;
            const { overloadedToolBar } = this.state;
            const content = document.querySelector(`#${tableId}`);
            const toolbarChildren = document.querySelectorAll(`#${tableId} .cds--toolbar-content > div:not(.cds--search), #${tableId} .cds--toolbar-content > button, #${tableId} .cds--toolbar-content > span`);
            let contentWidth = disableFilter ? 0 : 208;
            toolbarChildren.forEach(item => contentWidth += (item === null || item === void 0 ? void 0 : item.clientWidth) || 0);
            const overloaded = contentWidth >= ((content === null || content === void 0 ? void 0 : content.clientWidth) || 0);
            if ((content === null || content === void 0 ? void 0 : content.clientWidth) && toolbarChildren.length && overloaded !== overloadedToolBar) {
                this.setState({ overloadedToolBar: overloaded });
            }
        };
        this.checkMaxPagination = () => {
            const { tableId } = this.props;
            const content = document.querySelector(`#${tableId}`);
            const pagination = document.querySelector(`#${tableId} .aspera-form-pagination-wrapper`);
            const difference = ((pagination === null || pagination === void 0 ? void 0 : pagination.scrollWidth) || 0) - ((content === null || content === void 0 ? void 0 : content.clientWidth) || 0);
            if (!this.lastPaginationDifference || difference > this.lastPaginationDifference) {
                this.lastPaginationDifference = difference;
                this.setState({ paginationSmall: difference > 16 });
            }
        };
        this.reloadTableExternal = () => {
            const { staticRowData, alterDataStore, filterTextChange } = this.props;
            if (staticRowData) {
                this.rows = typeof alterDataStore === 'function' ? alterDataStore(staticRowData) : staticRowData;
                this.setState({}, () => {
                    this.forceRowUpdater.next({ row: undefined, id: 'ASPERA_TABLE_UPDATE' });
                });
            }
            else {
                this.getRowData();
            }
            if (typeof filterTextChange === 'function')
                filterTextChange(this.tableData.filterText);
        };
        this.triggerFilter = () => {
            const { filterTextChange } = this.props;
            if (typeof filterTextChange === 'function')
                filterTextChange(this.tableData.filterText);
            this.filter();
        };
    }
    /** Default error props text */
    get defaultErrorProps() {
        const { errorResponse } = this.state;
        const { getErrorText } = this.props;
        const backupMessage = (typeof getErrorText === 'function' && errorResponse) ? getErrorText(errorResponse) : undefined;
        return {
            title: language.get('table.unableToLoad'),
            body: backupMessage || language.get('table.unableToLoadDescription'),
        };
    }
    get hasBatchActions() {
        const { batchActions, onBatchChange, radioOnSelect } = this.props;
        return !!(((Array.isArray(batchActions) && batchActions.filter(action => !action.hidden).length) || onBatchChange) && typeof radioOnSelect !== 'function');
    }
    get idToUse() {
        const { itemIdKey } = this.props;
        return itemIdKey || 'id';
    }
    get rows() {
        return iterableToArray(this.internalItems.values());
    }
    set rows(items) {
        this.internalItems.clear();
        items.forEach(item => {
            if (typeof item === 'object') {
                this.internalItems.set(item[this.idToUse], item);
            }
        });
    }
    updateApiUrl(url, resetNextHeader) {
        const { nextPagingKey, overrideDefaultSortParam, overrideDefaultFilterParam, nodePostFilterType, nextPagingKeyFromHeaderQuery } = this.props;
        const urlParts = url.split('?');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const urlParams = getQueryParams(`?${urlParts[1]}`);
        delete urlParams[overrideDefaultSortParam || 'sort'];
        delete urlParams[overrideDefaultFilterParam || 'q'];
        if (nextPagingKeyFromHeaderQuery) {
            urlParams.per_page = this.tableData.pageSize;
            if (resetNextHeader) {
                this.nextTokens.next = '';
                delete urlParams[nextPagingKeyFromHeaderQuery];
            }
            else if (this.nextTokens.next) {
                urlParams[nextPagingKeyFromHeaderQuery] = this.nextTokens.next;
            }
        }
        else if (nextPagingKey) {
            urlParams.offset = (this.tableData.page - 1) * this.tableData.pageSize;
            if (urlParams.offset < 0)
                urlParams.offset = 0;
            urlParams.limit = this.tableData.pageSize;
        }
        else {
            urlParams.page = this.tableData.page;
            urlParams.per_page = this.tableData.pageSize;
        }
        if (!nodePostFilterType) {
            if (this.tableData.apiSortKey) {
                urlParams[overrideDefaultSortParam || 'sort'] = this.tableData.apiSortKey;
            }
            if (this.tableData.filterText) {
                urlParams[overrideDefaultFilterParam || 'q'] = encodeURIComponent(this.tableData.filterText.trim());
            }
        }
        if (this.advancedFilterData && Object.keys(this.advancedFilterData).length) {
            Object.keys(this.advancedFilterData).forEach(key => {
                urlParams[key] = this.advancedFilterData[key];
                if (urlParams[key] === undefined)
                    delete urlParams[key];
            });
        }
        return `${urlParts[0]}${getParamString(urlParams)}`;
    }
    getRowData(direction) {
        const { apiData, nextPagingKey, alterDataStore, staticRowData, nodePostFilterType, blindPagingUrlExchange, nextPagingKeyFromHeader, onError, overrideApiCalls } = this.props;
        this.setState({ loading: true, error: false });
        const tableErrorCall = (error, dataForApi) => {
            new AsperaError('AsperaDataTable: Unable to get rows', { error, apiData: dataForApi });
            this.setState({ error: true, loading: false, errorResponse: error === null || error === void 0 ? void 0 : error.response });
            if (typeof onError === 'function')
                onError(error === null || error === void 0 ? void 0 : error.response);
        };
        const handleTableSuccess = (responseData, response, url) => {
            this.rows = typeof alterDataStore === 'function' ? alterDataStore(responseData, response) : responseData;
            if (!this.rows.length && this.tableData.page !== 1) {
                new AsperaError('AsperaDataTable: Encountered empty page on non first page', { url: url, page: this.tableData.page, pageSize: this.tableData.pageSize, filterText: this.tableData.filterText });
                this.changePage({ page: 1, pageSize: this.tableData.pageSize });
                return;
            }
            this.setState({ loading: false }, () => {
                this.checkOverloadedToolbar();
                this.checkMaxPagination();
            });
        };
        if (typeof overrideApiCalls === 'function') {
            this.subManager.unsubscribe(this.lastApiCallId);
            this.lastApiCallId = this.subManager.setSubscription(overrideApiCalls(this.tableData).subscribe({
                next: response => {
                    this.totalItems = response.totalItems;
                    handleTableSuccess(response.data);
                },
                error: error => {
                    tableErrorCall(error, { type: 'custom' });
                },
            }));
            return;
        }
        if (apiData && staticRowData) {
            throw new AsperaError('AsperaDataTable: apiData and staticRowData cannot be used together').getError();
        }
        else if (staticRowData) {
            this.disablePaginationInternal = true;
            this.rows = typeof alterDataStore === 'function' ? alterDataStore(staticRowData) : staticRowData;
            this.setState({ loading: false });
            return;
        }
        else if (!apiData) {
            return;
        }
        if (typeof blindPagingUrlExchange === 'function' && direction) {
            apiData.url = blindPagingUrlExchange(direction === 'NEXT' ? this.nextTokens.next : this.nextTokens.first);
        }
        apiData.url = this.updateApiUrl(apiData.url || '', direction !== 'NEXT');
        if (nodePostFilterType && apiData.data) {
            delete apiData.data.sort;
            if (apiData.data.filters) {
                apiData.data.filters.basenames = this.tableData.filterText ? [[`*${this.tableData.filterText}*`]] : [];
            }
            switch (this.tableData.sortKey) {
                case 'size':
                    apiData.data.sort = this.tableData.isSortReversed ? 'size_a' : 'size_d';
                    break;
                case 'path':
                    // There is no reverse so just reset to one way
                    this.tableData.sortKey = 'path';
                    break;
                case 'mtime':
                    apiData.data.sort = this.tableData.isSortReversed ? 'mtime_a' : 'mtime_d';
                    break;
            }
        }
        this.subManager.unsubscribe(this.lastApiCallId);
        this.lastApiCallId = this.subManager.setSubscription(Axios.request(apiData).subscribe({
            next: response => {
                var _a, _b;
                this.totalItems = nextPagingKey ? response.data.total_count || 0 : ((response === null || response === void 0 ? void 0 : response.headers) && response.headers['x-total-count']) ? Number(response.headers['x-total-count']) : 0;
                let responseData = undefined;
                if (nextPagingKey) {
                    if (nextPagingKey.indexOf('.') > -1) {
                        const keyParts = nextPagingKey.split('.');
                        if (keyParts.length === 2 && response.data[keyParts[0]]) {
                            responseData = response.data[keyParts[0]][keyParts[1]];
                        }
                        if (keyParts.length === 3 && response.data[keyParts[0]] && response.data[keyParts[0]][keyParts[1]]) {
                            responseData = response.data[keyParts[0]][keyParts[1]][keyParts[2]];
                        }
                    }
                    else {
                        responseData = response.data[nextPagingKey];
                    }
                }
                else {
                    responseData = response.data;
                }
                if (nextPagingKeyFromHeader) {
                    this.nextTokens.next = response.headers[nextPagingKeyFromHeader] || '';
                    this.nextTokens.first = 'FIRST';
                }
                if (blindPagingUrlExchange && !nextPagingKeyFromHeader) {
                    this.nextTokens.next = ((_a = response.data.next) === null || _a === void 0 ? void 0 : _a.href) || '';
                    this.nextTokens.first = ((_b = response.data.first) === null || _b === void 0 ? void 0 : _b.href) || '';
                }
                if (Array.isArray(responseData)) {
                    handleTableSuccess(responseData, response, apiData.url);
                }
                else {
                    new AsperaError('AsperaDataTable: Response was not an array', { data: response.data, apiData });
                    if (typeof onError === 'function')
                        onError(response.data);
                    return this.setState({ error: true, loading: false });
                }
            },
            error: error => {
                tableErrorCall(error, apiData);
            },
        }));
    }
    getBodyContent() {
        const { errorProps } = this.props;
        const { error, contextMenuProps, overloadedToolBar } = this.state;
        if (error) {
            resetTableStore(true);
            return React.createElement(AsperaErrorState, Object.assign({}, (errorProps || this.defaultErrorProps)));
        }
        else {
            return (React.createElement("div", { className: `table-container ${overloadedToolBar ? 'aspera-data-table--overloaded-toolbar' : undefined}` },
                React.createElement(TableContainer, null,
                    this.getTableToolbar(),
                    this.getDataTableContainer()),
                this.getPagination(),
                contextMenuProps ? React.createElement(AsperaContextMenu, Object.assign({}, contextMenuProps)) : undefined));
        }
    }
    getAllOverflowIsEllipsis() {
        const { getOverflowMenu } = this.props;
        return !!this.rows.filter(row => {
            if (typeof getOverflowMenu === 'function') {
                const menus = (getOverflowMenu(row) || []).filter(menu => (!menu.disabled && !menu.hidden));
                return menus.length > 2;
            }
            return false;
        }).length;
    }
    getOverflow(row, allEllipsis) {
        const { getOverflowMenu, overflowAlwaysInEllipsis } = this.props;
        let inOverflow = false;
        if (typeof getOverflowMenu === 'function') {
            let children = null;
            const menus = (getOverflowMenu(row) || []).filter(menu => (!menu.disabled && !menu.hidden));
            if (!allEllipsis && !overflowAlwaysInEllipsis) {
                children = (React.createElement("div", { className: "overflow-grouping" }, menus.map((menu, index) => {
                    if (!menu.icon)
                        new AsperaError('AsperaDataTable: Overflow loaded as icon without icon');
                    return (React.createElement(Button, { className: `cds--overflow-menu ${menus.length === 1 ? 'standalone' : ''}`, disabled: menu.disabled, key: index, "data-auto": `table-row-button-${menu.name}`, onClick: () => {
                            menu.onClick(row);
                        }, hasIconOnly: true, renderIcon: menu.icon || getIconComponent('Settings'), tooltipPosition: language.leftRightStyle ? 'right' : 'left', iconDescription: menu.name }));
                })));
            }
            else {
                const childrenItems = menus.filter(menu => !menu.hidden).map((menu, index) => {
                    return (React.createElement(OverflowMenuItem, { key: index, title: language.get('table.menu'), iconDescription: language.get('table.menu'), disabled: menu.disabled, itemText: menu.name, "data-auto": `table-row-overflow-button-${menu.name}`, onClick: () => {
                            menu.onClick(row);
                        } }));
                });
                if (childrenItems.length) {
                    inOverflow = true;
                    children = (React.createElement(OverflowMenu, { iconDescription: language.get('lists.viewOptions'), title: language.get('lists.viewOptions'), "aria-label": language.get('lists.viewOptions'), flipped: !language.leftRightStyle, className: "standalone" }, childrenItems.map(child => child)));
                }
            }
            return {
                inOverflow,
                view: React.createElement(TableCell, { className: "aspera-cell-overflow" }, children),
            };
        }
        return { inOverflow, view: undefined };
    }
    get needsOverflowWidth() {
        const { tableId } = this.props;
        const mainTable = document.querySelector(`#${tableId}`);
        if (mainTable) {
            if (!this.hasResize) {
                return true;
            }
            else {
                return mainTable.clientWidth < this.clientWidth;
            }
        }
        return false;
    }
    getTableActions() {
        const { tableActions, actionOverflowIcon, actionOverflowDescription, asperaOverflowButtonProps, staticRowData, disableRefreshTable, disableSaveTable } = this.props;
        const actionsToUse = (tableActions === null || tableActions === void 0 ? void 0 : tableActions.filter(action => !action.hidden)) || [];
        const overflowButton = asperaOverflowButtonProps ? React.createElement(AsperaOverflowButton, Object.assign({}, asperaOverflowButtonProps, { flipped: true })) : undefined;
        const supportRefresh = !disableRefreshTable && !staticRowData;
        const supportSave = !disableSaveTable && !getEnvironmentVar('disable_table_export') && !this.isBlindPaging;
        if (!actionsToUse.length && !supportRefresh && !supportSave) {
            return overflowButton || null;
        }
        const primaryAction = actionsToUse[0];
        const secondaryActions = actionsToUse.slice(1).filter(action => action.alwaysShow);
        const actions = actionsToUse.slice(1).filter(action => !action.alwaysShow);
        if (supportRefresh) {
            actions.push({
                name: language.get('table.refreshTable'),
                onClick: () => {
                    this.getRowData();
                },
            });
        }
        if (supportSave) {
            actions.push({
                name: language.get('downloadAsCsv.saveTable'),
                onClick: () => {
                    downloadTableAsCsv(this.props, this.subManager);
                },
            });
            actions.push({
                name: language.get('downloadAsCsv.saveTableRaw'),
                onClick: () => {
                    downloadTableAsCsv(this.props, this.subManager, true);
                },
            });
        }
        if (this.hasResize) {
            actions.push({
                name: language.get('table.resetTable'),
                onClick: () => {
                    this.tableData.clearAdvancedFilters();
                    this.tableData.clearTableSizing();
                    this.hasResize = false;
                    generateTableDataUpdate();
                    this.getRowData();
                },
            });
        }
        const tableMenu = (React.createElement(TableToolbarMenu, { iconDescription: actionOverflowDescription || language.get('table.options'), renderIcon: actionOverflowIcon, "data-auto": "table-toolbar-menu-actions" }, actions.map((action, index) => React.createElement(TableToolbarAction, { key: index, itemText: action.name, onClick: action.onClick, "data-auto": `table-toolbar-menu-action-item-${action.name}` }))));
        const button = primaryAction ? React.createElement(Button, { kind: primaryAction.kind || 'primary', tooltipPosition: "left", "data-auto": `table-toolbar-action-item-${primaryAction.name}`, onClick: () => {
                clearFocus();
                primaryAction.onClick();
            }, hasIconOnly: primaryAction.iconOnlyMode, iconDescription: primaryAction.name, renderIcon: primaryAction.icon }, primaryAction.iconOnlyMode ? undefined : primaryAction.name) : undefined;
        const secondaryButtons = secondaryActions.map((action, index) => {
            return React.createElement(Button, { key: index, kind: action.kind || 'primary', onClick: () => {
                    clearFocus();
                    action.onClick();
                }, "data-auto": `table-toolbar-action-item-${action.name}`, tooltipPosition: "left", hasIconOnly: action.iconOnlyMode, iconDescription: action.name, renderIcon: action.icon }, action.iconOnlyMode ? undefined : action.name);
        });
        return (React.createElement(React.Fragment, null,
            actions.length ? tableMenu : undefined,
            secondaryButtons,
            button,
            overflowButton));
    }
    get allItemsChecked() {
        return !!(this.rows.filter(row => !!this.checkedItems.get(String(row[this.idToUse]))).length === this.rows.filter(row => !(row.tableRowDisabled || row.tableRowNotSelectable)).length);
    }
    getColumnEditAction() {
        const { headerData } = this.props;
        if (!this.supportCustomColumns)
            return;
        // WARNINGS from react are coming from the FloatingMenu component in Carbon for invalid props.
        return (React.createElement(OverflowMenu, { flipped: !language.leftRightStyle, renderIcon: getIconComponent('Column'), className: "column-edit cds--toolbar-action cds--overflow-menu cds--overflow-menu", iconDescription: language.get('table.editColumns'), title: language.get('table.editColumns'), "aria-label": language.get('table.editColumns') }, headerData.map((header, index) => {
            if (!header.name)
                return null;
            return (React.createElement("div", { className: "cds--overflow-menu-options__option column-edit--item", title: header.name, key: index },
                React.createElement("span", { className: "cds--overflow-menu-options__btn" },
                    React.createElement(Checkbox, { "data-auto": `column-edit-checkbox-${header.key}`, id: getRandomId(), checked: !!this.currentRenderedHeaders.get(header.key), labelText: header.name, onChange: (_event, data) => {
                            this.customizedTable = true;
                            data.checked ? this.currentRenderedHeaders.set(header.key, { index, header }) : this.currentRenderedHeaders.delete(header.key);
                            this.setState({});
                        } }))));
        })));
    }
    getAdvancedFilterButton() {
        const { advancedFilters, advancedFilterQueryExchange } = this.props;
        if (advancedFilters && advancedFilterQueryExchange) {
            return React.createElement(Button, { kind: "ghost", hasIconOnly: true, size: "lg", renderIcon: getIconComponent('Filter'), iconDescription: language.get('table.filters'), tooltipAlignment: "end", tooltipPosition: "left", onClick: this.handleAdvancedFilter, "data-auto": "table-toolbar-filter" });
        }
        else {
            return null;
        }
    }
    get showingBatchActions() {
        const { batchActions } = this.props;
        return !!((this.hasBatchActions && (batchActions === null || batchActions === void 0 ? void 0 : batchActions.length)) && !!this.checkedItems.size);
    }
    get clientWidth() {
        const { tableId } = this.props;
        const innerTable = document.querySelector(`#${tableId} tbody`);
        return (innerTable === null || innerTable === void 0 ? void 0 : innerTable.clientWidth) || 320;
    }
    get tableWidthClass() {
        let className = 'xl';
        const width = this.clientWidth;
        if (width < 1600) {
            className = 'desktop';
        }
        if (width < 1100) {
            className = 'tablet';
        }
        if (width < 760) {
            className = 'mobile';
        }
        return className;
    }
    getTableToolbar() {
        const { disableFilter, searchOnEnter } = this.props;
        return (React.createElement(TableToolbar, null,
            this.showingBatchActions ? this.getBatchItems() : undefined,
            !this.showingBatchActions && React.createElement(TableToolbarContent, { onClick: this.handleToolbarAreaClick },
                disableFilter ? undefined : (React.createElement(TableToolbarSearch, { value: this.tableData.filterText || '', translateWithId: this.translateToolbarSearch, persistent: !!this.tableData.filterText, closeButtonLabelText: language.get('table.clearSearch'), onKeyUp: searchOnEnter ? (event) => {
                        if (searchOnEnter && event.key === 'Enter') {
                            this.triggerFilter();
                        }
                    } : undefined, onChange: (event) => {
                        var _a;
                        this.tableData.filterText = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
                        this.filterSub.next('');
                        this.setState({});
                    } })),
                this.getAdvancedFilterButton(),
                this.getColumnEditAction(),
                this.getTableActions())));
    }
    get currentHeaderItems() {
        return iterableToArray(this.currentRenderedHeaders.values()).sort((a, b) => (a.index - b.index)).map(header => header.header);
    }
    get numberOfCalculatedColumns() {
        const { getOverflowMenu } = this.props;
        let count = 0;
        const allowAllCheckbox = !!this.rows.filter(row => !(row.tableRowDisabled || row.tableRowNotSelectable)).length;
        if (this.hasBatchActions && allowAllCheckbox)
            count++;
        if (typeof getOverflowMenu === 'function')
            count++;
        count = count + this.currentHeaderItems.length;
        return count;
    }
    get numberOfVisibleColumns() {
        const { tableId } = this.props;
        try {
            let count = 0;
            const allHeaders = document.querySelectorAll(`#${tableId} th`);
            if (allHeaders) {
                allHeaders.forEach(header => {
                    const styles = window.getComputedStyle(header);
                    if ((styles === null || styles === void 0 ? void 0 : styles.display) !== 'none') {
                        count++;
                    }
                });
            }
            return count;
        }
        catch (error) {
            new AsperaError('AsperaDataTable: unable to calculate visible columns', error);
            return this.numberOfCalculatedColumns;
        }
    }
    getDataTableContainer() {
        const { emptyProps, searchEmptyProps, getOverflowMenu, radioOnSelect, tableId, genericTable } = this.props;
        const { loading } = this.state;
        if (loading) {
            return React.createElement(AsperaDataTableSkeleton, { rowCount: this.tableData.pageSize || 5, columnData: this.currentHeaderItems, hasBatchActions: this.hasBatchActions, hasOverflow: !!getOverflowMenu, tableId: tableId, genericTable: genericTable });
        }
        else if (this.rows.length === 0 && this.tableData.filterText) {
            return React.createElement(AsperaEmptyState, Object.assign({ className: "hover-light-area", emptyByFilter: true }, (searchEmptyProps || this.defaultSearchEmptyProps)));
        }
        else if (this.rows.length === 0) {
            return React.createElement(AsperaEmptyState, Object.assign({ className: "hover-light-area" }, (emptyProps || this.defaultEmptyProps)));
        }
        else {
            let notInOverflow = false;
            const allowAllCheckbox = !!this.rows.filter(row => !(row.tableRowDisabled || row.tableRowNotSelectable)).length;
            const allowAllExpand = !!this.rows.filter(row => row.tableRowExpandedContent).length;
            let needStateLoad = false;
            const tableBody = (React.createElement(TableBody, null, this.rows.map((row, index) => {
                const id = String(row[this.idToUse]);
                if ((row.tableRowDisabled || row.tableRowNotSelectable) && this.checkedItems.get(id)) {
                    this.checkedItems.delete(id);
                    needStateLoad = true;
                }
                const isChecked = !!this.checkedItems.get(id);
                const isDragOver = (!getEnvironmentVar('use_mouse_for_drag') && dragging.dragOverItem && String(dragging.dragOverItem[this.idToUse]) === id && dragging.dragOverItemTableId === tableId);
                const overflowData = this.getOverflow(row, this.getAllOverflowIsEllipsis());
                if (!overflowData.inOverflow)
                    notInOverflow = true;
                const rowProps = {
                    'data-auto': `table-row-${index}`,
                    style: row.asperaTableRowStyle,
                    className: `aspera-row aspera-row-item-${(index % 21) + 1} ${isChecked ? 'cds--data-table--selected' : ''} ${isDragOver ? 'aspera-drag-over' : ''} ${row.tableRowDisabled ? 'aspera-table-disabled-row' : ''} ${row.tableRowCustomClass ? row.tableRowCustomClass : ''}`,
                    [getEnvironmentVar('use_mouse_for_drag') ? 'onMouseOver' : 'onDragEnter']: row.tableRowDroppable ? (event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        this.handleDragEvent(row, id, event);
                    } : undefined,
                    onDrop: row.tableRowDroppable ? (event) => {
                        if (dragging.safeCurrentItemsDragged.length) {
                            event.preventDefault();
                            event.stopPropagation();
                            this.handleDropEvent(row, event);
                        }
                    } : undefined,
                    draggable: row.tableRowDraggable,
                    onDragStart: row.tableRowDraggable ? (event) => {
                        if (event && event.dataTransfer && typeof event.dataTransfer.setData === 'function') {
                            event.dataTransfer.setData('text/plain', 'aspera_data_table');
                        }
                        this.startDraggingItems(id, row, event);
                    } : undefined,
                    onDragEnd: (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        dragging.triggerResetDrag();
                    },
                    onContextMenu: (event) => {
                        if (row.tableRowDisabled)
                            return;
                        this.handleRightClick(id, row, event);
                    },
                };
                const rowChildren = (React.createElement(React.Fragment, null,
                    this.hasBatchActions ? (React.createElement(TableSelectRow, { "data-auto": `table-row-checkbox-item-${index}`, checked: isChecked, disabled: row.tableRowDisabled || row.tableRowNotSelectable, "aria-label": language.get('table.selectRow'), name: language.get('table.selectRow'), id: `${this.idPrefixToUse}-${id}`, onSelect: () => {
                            this.batchSelect(id, row);
                        } })) : undefined,
                    typeof radioOnSelect === 'function' ? (React.createElement("td", { className: "cds--table-column-checkbox" },
                        React.createElement(RadioButton, { id: `${this.idPrefixToUse}-${id}-radio`, "data-auto": `table-row-radio-item-${index}`, disabled: row.tableRowDisabled || row.tableRowNotSelectable, checked: this.radioSelectedRow === id, onChange: () => {
                                this.radioSelect(id, row);
                            } }))) : undefined,
                    this.currentHeaderItems.map((header, headIndex) => this.getTableCell(row, id, header, headIndex)),
                    overflowData.view));
                return row.tableRowExpandedContent ? (React.createElement(React.Fragment, { key: `expand-${index}` },
                    React.createElement(TableExpandRow, Object.assign({ isExpanded: row.expanded || false, onExpand: () => {
                            row.expanded = !row.expanded;
                            this.setState({});
                        }, key: index, "aria-label": language.get('table.expandRow') }, rowProps), rowChildren),
                    React.createElement(TableExpandedRow, { colSpan: this.numberOfVisibleColumns }, row.tableRowExpandedContent))) : (React.createElement(TableRow, Object.assign({ key: index }, rowProps),
                    allowAllExpand && React.createElement("td", { className: "cds--table-expand" }),
                    rowChildren));
            })));
            if (needStateLoad) {
                setTimeout(() => {
                    this.setState({});
                });
            }
            return (React.createElement(Table, { isSortable: true },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, { "data-auto": "table-header" },
                        allowAllExpand && React.createElement(TableExpandHeader, null),
                        this.hasBatchActions && allowAllCheckbox ? (React.createElement(TableSelectAll, { "data-auto": "table-header-select-all", checked: this.allItemsChecked, "aria-label": language.get('table.selectAll'), name: language.get('table.selectAll'), id: `${this.idPrefixToUse}-all`, onSelect: () => {
                                this.batchSelect('ALL');
                            } })) : undefined,
                        this.hasBatchActions && !allowAllCheckbox ? (React.createElement("th", { className: "no-checkbox-placeholder cds--table-column-checkbox", scope: "col" })) : undefined,
                        typeof radioOnSelect === 'function' ? (React.createElement("th", { className: "radio-placeholder cds--table-column-checkbox", scope: "col" })) : undefined,
                        this.getHeaders(),
                        typeof getOverflowMenu === 'function' ? React.createElement(TableHeader, { style: { minWidth: `${notInOverflow ? '96' : '64'}px`, width: this.needsOverflowWidth ? `${notInOverflow ? '96' : '64'}px` : undefined }, className: "aspera-cell-overflow" }) : undefined)),
                tableBody));
        }
    }
    get isBlindPaging() {
        const { blindPagingUrlExchange, nextPagingKeyFromHeader } = this.props;
        return !!(blindPagingUrlExchange || nextPagingKeyFromHeader);
    }
    // Design wants to hide if total is less than perPage
    get hidePagination() {
        const { disablePagination } = this.props;
        // Always show if blind pagination or blind pagination with header is used
        if (this.isBlindPaging && !disablePagination) {
            return false;
        }
        return disablePagination || this.disablePaginationInternal || (this.totalItems <= this.tableData.pageSizes[0].value);
    }
    getPagination() {
        const { tableId } = this.props;
        const { paginationLoading } = this.state;
        if (!this.hidePagination && !paginationLoading) {
            return (React.createElement(AsperaTablePagination, { className: `aspera-form-pagination-wrapper ${this.isBlindPaging ? 'blind-pagination' : ''}`, "data-auto": "table-pagination", pageSize: this.tableData.pageSize, onChange: this.changePage, itemsPerPageText: language.get('table.itemsPerPage'), backwardText: language.get(this.isBlindPaging ? 'table.firstPage' : 'table.previousPage'), forwardText: language.get('table.nextPage'), page: this.tableData.page, pageSizes: this.tableData.pageSizes, totalItems: this.isBlindPaging ? undefined : this.totalItems, itemRangeText: (min, max, total) => language.get('table.rangeOfTotal', [min, max, total]), pageText: (page) => language.get('table.pageItem', [page]), pageRangeText: (_page, total) => language.get(`table.${total === 1 ? 'pageRange' : 'pagesRange'}`, [total]), id: `aspera-table-pagination-${tableId}`, itemText: (min, max) => language.get('table.itemText', [min, max]), pageNumberText: language.get('table.pageNumber') }));
        }
    }
    get isGenericTable() {
        const { genericTable } = this.props;
        return !!(genericTable || this.isBlindPaging);
    }
    /**
     * When component updates check the following to know if data should be updated
     * When URL is updated
     * When data.path, data.filter is updated (Node POST)
     */
    componentDidUpdate(previousProps) {
        var _a, _b;
        const { apiData, showSelectedItems, radioInitiallySelectedItemId, tableId, ignoreUrlChange, defaultSortKey, disablePagination, groupTableId, genericAdvancedFilterTable } = this.props;
        this.originalUrl = (apiData === null || apiData === void 0 ? void 0 : apiData.url) || '';
        if (tableId !== previousProps.tableId) {
            this.tableData = new AsperaTableData(tableId, this.isGenericTable, groupTableId, genericAdvancedFilterTable);
            if (this.tableData.hasAdvancedFilterModel) {
                this.advancedFilterModel = this.tableData.advancedFilterModel;
                this.setAdvancedFilterModel();
            }
            if (defaultSortKey && !this.tableData.sortKey) {
                this.tableData.sortKey = defaultSortKey;
            }
            this.setState({});
        }
        if (showSelectedItems !== previousProps.showSelectedItems) {
            if (showSelectedItems) {
                this.setState({ loading: true });
                this.reloadTimer = setTimeout(() => {
                    this.disablePaginationInternal = true;
                    this.rows = iterableToArray(this.checkedItems.values());
                    this.setState({ loading: false });
                }, 1000);
                return;
            }
            else {
                this.disablePaginationInternal = false;
                this.getRowData();
            }
        }
        if (radioInitiallySelectedItemId !== previousProps.radioInitiallySelectedItemId) {
            this.radioSelectedRow = radioInitiallySelectedItemId;
        }
        if (!apiData || !previousProps.apiData)
            return;
        const url = (_a = apiData.url) === null || _a === void 0 ? void 0 : _a.split('?')[0];
        const previousUrl = (_b = previousProps.apiData.url) === null || _b === void 0 ? void 0 : _b.split('?')[0];
        if (disablePagination !== previousProps.disablePagination) {
            this.checkMaxPagination();
        }
        if (url !== previousUrl ||
            ((apiData.data && previousProps.apiData.data) && (apiData.data.path !== previousProps.apiData.data.path))) {
            if (ignoreUrlChange) {
                this.getRowData();
            }
            else {
                this.tableData.filterText = undefined;
                this.changePage({ page: 1, pageSize: this.tableData.pageSize });
            }
        }
    }
    componentWillUnmount() {
        if (this.reloadTimer)
            clearTimeout(this.reloadTimer);
        if (this.resizeTimeout)
            clearTimeout(this.resizeTimeout);
        this.subManager.unsubscribeAll();
    }
    componentDidMount() {
        const { defaultSortKey, customWrapperSelector, onDrop, forceUpdate, initiallySelectedItems, externalFilterSub, forceRowUpdater, headerData, radioOnSelect, batchActions, radioInitiallySelectedItemId, filterTextChange, initialAdvancedFilterModel, setInternalSelectedItems, apiData, clearSelectedItems, searchOnEnter } = this.props;
        if ((batchActions && batchActions.length) && typeof radioOnSelect === 'function') {
            throw new AsperaError('AsperaDataTable: batchActions cannot be used with radioOnSelect').getError();
        }
        this.originalUrl = (apiData === null || apiData === void 0 ? void 0 : apiData.url) || '';
        /** Do not set advanced filters to initial if already in memory */
        if (initialAdvancedFilterModel && !this.tableData.hasAdvancedFilterModel) {
            this.advancedFilterModel = initialAdvancedFilterModel;
            this.setAdvancedFilterModel();
        }
        // Setup initial headers for render
        headerData.forEach((header, index) => {
            if (header.initiallyHidden)
                return;
            this.currentRenderedHeaders.set(header.key, { index, header });
        });
        if (radioInitiallySelectedItemId) {
            this.radioSelectedRow = radioInitiallySelectedItemId;
        }
        this.supportCustomColumns = !!headerData.filter(header => header.initiallyHidden).length;
        // eslint-disable-next-line
        this.idPrefixToUse = this.props.tableId;
        this.subManager.setSubscription(dragging.triggerState.subscribe({
            next: () => {
                this.setState({});
            },
            error: error => {
                new AsperaError('AsperaDataTable: Drag Service state trigger encountered error', error);
            },
        }));
        this.subManager.setSubscription(this.filterSub.pipe(debounceTime(500)).subscribe({
            next: () => {
                if (!searchOnEnter || this.tableData.filterText === '') {
                    this.triggerFilter();
                }
            },
            error: error => {
                new AsperaError('AsperaDataTable: Unable to subscribe to DataTable Filter', error);
            },
        }));
        this.subManager.setSubscription(tracking.reloadTables.subscribe({
            next: () => {
                this.reloadTableExternal();
            },
            error: error => {
                new AsperaError('AsperaDataTable: Unable to subscribe to global force update observable', error);
            },
        }));
        if (forceUpdate) {
            this.subManager.setSubscription(forceUpdate.subscribe({
                next: () => {
                    this.reloadTableExternal();
                },
                error: error => {
                    new AsperaError('AsperaDataTable: Unable to subscribe to force update observable', error);
                },
            }));
        }
        if (setInternalSelectedItems) {
            this.subManager.setSubscription(setInternalSelectedItems.subscribe({
                next: items => {
                    this.radioSelectedRow = undefined;
                    this.checkedItems.clear();
                    items.filter(item => typeof item === 'object').forEach(item => {
                        this.checkedItems.set(item[this.idToUse], item);
                    });
                    this.setState({});
                },
                error: error => {
                    new AsperaError('AsperaDataTable: Unable to subscribe to update internal set items observable', error);
                },
            }));
        }
        if (typeof filterTextChange === 'function')
            filterTextChange(this.tableData.filterText);
        if (forceRowUpdater) {
            this.subManager.setSubscription(forceRowUpdater.subscribe({
                next: data => {
                    const handleAddRow = () => {
                        const rows = iterableToArray(this.internalItems.values()).map(row => row);
                        if (data.addToBottom) {
                            rows.push(data.row);
                        }
                        else {
                            rows.unshift(data.row);
                        }
                        this.totalItems++;
                        if (rows.length > this.tableData.pageSize) {
                            rows.pop();
                        }
                        this.rows = rows;
                        this.setState({});
                        // Force the children columns to update after they are rendered
                        this.forceRowUpdater.next({ row: undefined, id: 'ASPERA_TABLE_UPDATE' });
                    };
                    const id = String(data.row[this.idToUse]);
                    if (data.action === 'UPDATE') {
                        if (this.internalItems.get(id)) {
                            this.internalItems.set(id, data.row);
                        }
                        this.forceRowUpdater.next({ row: data.row, id });
                    }
                    else if (data.action === 'ADD' && (data.alwaysAdd || (this.tableData.page === 1 && this.tableData.sortKey === defaultSortKey))) {
                        handleAddRow();
                    }
                    else if (data.action === 'ADD-UPDATE') {
                        if (this.internalItems.get(id)) {
                            this.internalItems.set(id, data.row);
                            this.forceRowUpdater.next({ row: data.row, id });
                        }
                        else if (data.alwaysAdd || (this.tableData.page === 1 && this.tableData.apiSortKey === defaultSortKey)) {
                            handleAddRow();
                        }
                    }
                },
                error: error => {
                    new AsperaError('AsperaDataTable: Unable to subscribe to row force updater observable', error);
                },
            }));
        }
        if (Array.isArray(initiallySelectedItems)) {
            initiallySelectedItems.forEach(item => {
                this.checkedItems.set(item[this.idToUse], item);
            });
        }
        if (externalFilterSub) {
            this.subManager.setSubscription(externalFilterSub.subscribe({
                next: filterTerm => {
                    this.tableData.filterText = filterTerm;
                    this.filterSub.next(filterTerm);
                },
                error: error => {
                    new AsperaError('AsperaDataTable: Unable to subscribe to externalFilterSub observable', error);
                },
            }));
        }
        if (clearSelectedItems) {
            this.subManager.setSubscription(clearSelectedItems.subscribe({
                next: () => {
                    this.checkedItems.clear();
                },
                error: error => {
                    new AsperaError('AsperaDataTable: Unable to subscribe to clearSelectedItems observable', error);
                },
            }));
        }
        let element;
        if (customWrapperSelector) {
            element = document.querySelector(customWrapperSelector);
            if (!element) {
                element = window;
                new AsperaError('AsperaDataTable: Custom wrapper selector used but could not be found on DOM', { customWrapperSelector });
            }
        }
        else {
            element = window;
        }
        this.subManager.setSubscription(fromEvent(element, getEnvironmentVar('use_mouse_for_drag') ? 'mouseover' : 'dragover').subscribe({
            next: dragEvent => {
                dragEvent.preventDefault();
            },
            error: error => {
                new AsperaError('AsperaDataTable: Unable to subscribe to drag over Event', error);
            },
        }));
        this.subManager.setSubscription(monitorDrops(customWrapperSelector || 'body').subscribe({
            next: data => {
                const { tableId, droppable } = this.props;
                if (data.files.length) {
                    const dropItem = dragging.dragOverItem === tableId ? undefined : dragging.dragOverItem;
                    if (!dropItem && !droppable) {
                        return;
                    }
                    if (typeof onDrop === 'function') {
                        const inverse = altKeysUsed(data.event);
                        onDrop(dropItem || tableId, data.files, inverse, data.event, true);
                    }
                    dragging.triggerResetDrag();
                }
            },
            error: error => {
                new AsperaError('AsperaDataTable: Unable to subscribe to external file drop Event', error);
            },
        }));
        this.subManager.setSubscription(fromEvent(element, getEnvironmentVar('use_mouse_for_drag') ? 'mouseenter' : 'dragenter').subscribe({
            next: dragEvent => {
                const { tableId } = this.props;
                this.handleDragEvent(tableId, tableId, dragEvent);
            },
            error: error => {
                new AsperaError('AsperaDataTable: Unable to subscribe to drag enter Event', error);
            },
        }));
        this.subManager.setSubscription(fromEvent(element, 'drop').subscribe({
            next: dropEvent => {
                var _a;
                if (((_a = dragging.safeCurrentItemsDragged) === null || _a === void 0 ? void 0 : _a.length) && typeof dragging.dragOverItem !== 'object') {
                    this.handleDropEvent(undefined, dropEvent);
                }
            },
            error: error => {
                new AsperaError('AsperaDataTable: Unable to subscribe to Drop Event', error);
            },
        }));
        if (defaultSortKey && !this.tableData.sortKey) {
            this.tableData.sortKey = defaultSortKey;
        }
        this.subManager.setSubscription(fromEvent(window, 'resize').pipe(debounceTime(500)).subscribe({
            next: () => {
                this.checkMaxPagination();
                this.checkExpandableSettings();
                this.checkOverloadedToolbar();
                this.setState({});
            },
            error: error => {
                new AsperaError('AsperaDataTable: cannot setup resize event on window', error);
            },
        }));
        this.subManager.setSubscription(fromEvent(window, 'mousemove').subscribe({
            next: (event) => {
                const mouseIsDown = event.buttons;
                let mousePosition = event.pageX;
                if (!mousePosition || mousePosition < 0) {
                    mousePosition = 0;
                }
                if (this.resizeInProgressItem.headerKey) {
                    if (mouseIsDown) {
                        this.resizeInProgressItem.current = mousePosition;
                        const diff = (this.resizeInProgressItem.current || 0) - (this.resizeInProgressItem.start || 0);
                        let newWidth = (this.resizeInProgressItem.startWidth || 0) + diff;
                        if (newWidth < 100) {
                            newWidth = 100;
                        }
                        this.tableData.setTableSizing(this.resizeInProgressItem.headerKey, newWidth);
                        this.setState({});
                    }
                    else {
                        this.resizeInProgressItem.headerKey = '';
                        this.resizeInProgressItem.start = undefined;
                        this.resizeInProgressItem.startWidth = undefined;
                        this.resizeInProgressItem.current = undefined;
                        generateTableDataUpdate();
                        this.setState({});
                    }
                }
            },
            error: error => {
                new AsperaError('AsperaDataTable: cannot setup resize event on window', error);
            },
        }));
        this.getRowData();
    }
    render() {
        const { className, tableId, droppable, groupTableId, genericAdvancedFilterTable } = this.props;
        const { paginationSmall } = this.state;
        if (this.firstLoad) {
            this.tableData = new AsperaTableData(tableId, this.isGenericTable, groupTableId, genericAdvancedFilterTable);
            if (this.tableData.hasAdvancedFilterModel) {
                this.advancedFilterModel = this.tableData.advancedFilterModel;
                this.setAdvancedFilterModel();
            }
            this.firstLoad = false;
        }
        return (React.createElement("div", { id: tableId, className: `aspera-data-table ${className ? className : ''} table-width-${this.tableWidthClass} ${this.customizedTable ? 'aspera-customized-table-override' : ''} ${(dragging.dragOverItem === tableId && droppable && !getEnvironmentVar('use_mouse_for_drag')) ? 'aspera-drag-over' : ''} ${paginationSmall ? 'aspera-small-pagination' : ''} ${this.resizeInProgressItem.headerKey ? 'resizing-column' : ''}`, "data-auto": "table-body" }, this.getBodyContent()));
    }
});
